import React, { useState } from 'react'
import { Button, Col, Form, Row } from 'antd'
import { FormBox, InputBox } from '../../../../components/AntdAddons'
import OtpInput from "react-otp-input"
import { rules } from './Rules'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../../../../store/app'
import { assignErrorToInput } from '../../../../store/api'
import { forgotPassword, verifyOtp } from '../../../../store/AuthSlice'
import { Link, useNavigate } from 'react-router-dom'
import loginlogo from "../../../../assets/images/login-logo.svg"
import loginbgMob from "../../../../assets/images/login-img-new-mobile.svg"
import { WebConstant } from '../../webConstant/WebConstant'

/**
 * Renders the Forgot Password component.
 *
 * @return {JSX.Element} The rendered ForgotPassword component.
 */
const ForgotPassword = () => {
    const [showOtp, setShowOtp] = useState<boolean>(false)
    const dispatch: AppDispatch = useDispatch<any>();
    const navigate = useNavigate()
    const [form] = Form.useForm();
    const [otp, setOtp] = useState("");
    const [emailId, setEmailId] = useState("")
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);

    const handleSubmit = (data: any) => {
        setLoading(true)
        dispatch(forgotPassword(data))
            .then(() => {
                setLoading(false)
                setEmailId(data.email)
                setShowOtp(true)
            })
            .catch((error: any) => {
                setLoading(false);
                assignErrorToInput(form, error?.STATUS)
            })
    }

    // Send OTP on User Email Id for password reset
    const submitOtp = () => {
        setLoading2(true)

        let requestData={
            otp:otp,
            email:emailId,
        }
        dispatch(verifyOtp(requestData))
            .then((response: any) => {
                setLoading2(false)
                navigate(`/reset/${response.token}`)
            })
            .catch((error: any) => {
            setLoading2(false);
            assignErrorToInput(form, error?.STATUS)
        })
    }
    const logo = useSelector((state: RootState) => state.HOME.pageSettings?.banner?.banner_logo)

    return (
        <>
            <section className='webLoginSection webForgotPassword '>
                <div className="ant-row no-gutter">

                    <div className="ant-col-xxl-12 ant-col-xl-12 ant-col-lg-12 ant-col-md-12">
                        <div className="login-bg">
                            <div className="login-bg-in"><img src={loginbgMob} alt="" /></div>
                        </div>
                    </div>

                    <div className="ant-col-xxl-12 ant-col-xl-12 ant-col-lg-12 ant-col-md-12 form-col">
                        <div className='webLoginBox'>
                            <div className="login-logo">
                                <Link to={'/login'}>
                                    <img src={WebConstant?.IMAGE_URL + logo} alt="" />
                                </Link>
                            </div>
                            <h2 className="subtitle">Reset Password</h2>
                            <FormBox form={form} onFinish={handleSubmit}>
                                <Row>
                                    <Col sm={24} xs={24} md={24} xxl={24}>
                                        <InputBox.Text
                                            name="email"
                                            label={<>Email Address<em>*</em></>}
                                            placeholder=''
                                            className='ecn-input'

                                            rules={rules.email()}
                                        />
                                    </Col>
                                </Row>
                                <div className='logInBtn'>
                                    <Button 
                                    className='log_in_button secondry_btn_log_page' 
                                    htmlType="submit"
                                    loading={loading}>
                                        {showOtp ? 'Resend otp':'Send otp' }
                                    </Button>
                                </div>
                            </FormBox>
                            {showOtp &&
                                <>
                                    <h2 className="subtitle otpTitle">Enter OTP</h2>
                                    <OtpInput
                                        containerStyle="otpInput"
                                        value={otp}
                                        inputType="number"
                                        onChange={(otp: any) => setOtp(otp)}
                                        numInputs={4}
                                        renderInput={(props: any) => <input  {...props} />}

                                    />

                                    <div className='logInBtn'>
                                        <Button 
                                        className='log_in_button secondry_btn_log_page' 
                                        onClick={submitOtp}
                                        loading={loading2}>
                                            Submit
                                        </Button>
                                    </div>
                                </>
                            }
                        </div>
                    </div>

                </div>
            </section>
        </>
    )
}

export default ForgotPassword